<template>
  <b-img :class="cssClass" :rounded="rounded" :width="width" :height="height" :src="enderecoImagem" :alt="alt" />
</template>

<script>
import ImageStream from './js'
export default ImageStream
</script>
